<app-device-features-container
  header="{{ '+INSTALLATIONS.INSTALLATION.PANEL.FUEL_CELL.TITLE' | translate }}"
  [overlayType]="availableOverlays.FuelCell"
  [deviceSelectId]="deviceSelectId"
>
  <ng-container feature *ngIf="heatingDhw$ | async | ready; else dhwFallback">
    <app-feature-tile
      feature
      *ngIf="storageTankSensorBottom$ | async | ready as feature"
      [label]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.BOTTOM_CYLINDER_TEMP_SENSOR'
          | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    ></app-feature-tile>
    <app-feature-tile
      feature
      *ngIf="storageTankSensorTop$ | async | ready as feature"
      [label]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.TOP_CYLINDER_TEMP_SENSOR'
          | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    ></app-feature-tile>
    <app-feature-tile
      feature
      *ngIf="volumetricFlowReturn$ | async | ready as feature"
      [label]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.VOLUMETRIC_FLOW' | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
    ></app-feature-tile>
  </ng-container>
  <ng-template #dhwFallback>
    <!-- fuelCell.operating.phase -->
    <app-feature-tile
      feature
      *ngIf="fuelCellOperatingPhase$ | async | ready as feature"
      [label]="'+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.STATUS' | translate"
      [value]="feature | value2: featurePropertyKey.value | translateFuelCellPhase"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    ></app-feature-tile>
    <!-- heating.power.production.current -->
    <app-feature-tile
      feature
      *ngIf="powerOutput$ | async | ready as feature"
      [label]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.ELECTRICAL_OUTPUT' | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    ></app-feature-tile>
    <!-- fuelCell.sensors.temperature.supply -->
    <app-feature-tile
      feature
      *ngIf="powerOutput$ | async | ready as feature"
      [label]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.FUEL_FLOW_TEMP_SENSOR'
          | translate
      "
      value="{{ fuelCellSupplyTemperature$ | async | ready | value2: featurePropertyKey.value }} {{
        fuelCellSupplyTemperature$ | async | ready | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="fuelCellSupplyTemperature$ | async | ready | error"
    ></app-feature-tile>
    <!-- fuelCell.sensors.temperature.return -->
    <app-feature-tile
      feature
      *ngIf="fuelCellReturnTemperature$ | async | ready as feature"
      [label]="
        '+INSTALLATIONS.INSTALLATION.PANEL.OPERATIONAL_DATA.FUEL_CELL.RETURN_TEMP_SENSOR'
          | translate
      "
      value="{{ feature | value2: featurePropertyKey.value }} {{
        feature | unit: featurePropertyKey.value
      }}"
      [attr.data-feature]="feature.feature"
      [error]="feature | error"
    ></app-feature-tile>
  </ng-template>
</app-device-features-container>
